import appConst from "./appConst.json";

const SHIPPING_TITLE_KEY_BY_ID = {
  [String(appConst.ASAFTA)]: appConst.SHIPPING_METHOD_ASAFTA,
  [String(appConst.BHSHOPS)]: appConst.SHIPPING_METHOD_BHSHOPS,
  [String(appConst.BHHOME)]: appConst.SHIPPING_METHOD_BHHOME,
  [String(appConst.BOXIT_SHOPS)]: appConst.SHIPPING_METHOD_BHSHOPS,
  "19": appConst.SHIPPING_METHOD_BHSHOPS,
  [String(appConst.BOXIT_LOCKER)]: appConst.SHIPPING_METHOD_LOCKER,
  [String(appConst.REGISTERED)]: appConst.SHIPPING_METHOD_REGISTERED,
  "3": appConst.SHIPPING_METHOD_REGISTERED,
};

export const resolveShippingTitleKeyById = (id) =>
  SHIPPING_TITLE_KEY_BY_ID[String(id)] || null;

export const resolveShippingTitle = ({ id, getTranslation, fallbackTitle = "" }) => {
  const titleKey = resolveShippingTitleKeyById(id);
  const translatedTitle = titleKey ? getTranslation(titleKey) : "";

  return translatedTitle && translatedTitle !== titleKey
    ? translatedTitle
    : fallbackTitle;
};
